import { useQuery } from '@apollo/client';

import type { IOrderHistory, IOrderHistoryVariables } from './orderHistory.interface';
export type { IOrderHistory, IOrderHistoryVariables } from './orderHistory.interface';
import { shapeOrderHistory } from './shapeOrderHistory';
import { orderHistoryGql } from './gql';

interface IUseOrderHistoryQuery {
  OrderHistory: IOrderHistory[];
}

interface IUseOrderHistoryVariables extends IOrderHistoryVariables {
  initialRow: number;
  nextRows: number;
}

interface IUseOrderHistory {
  variables: IUseOrderHistoryVariables;
}

export const useOrderHistory = ({ variables }: IUseOrderHistory) => {
  const { loading, data, error } = useQuery<IUseOrderHistoryQuery>(orderHistoryGql, {
    context: {
      headers: {
        userFunctionKey: '9a1158154dfa42caddbd0694a4e9bdc8'
      }
    },
    variables
  });

  let orderHistory;
  if (!loading) {
    orderHistory = shapeOrderHistory(data?.OrderHistory);
  }

  return { loadingOrderHistory: loading, orderHistory, errorOrderHistory: error };
};
